import 'css-chunksrc/client/pages/exportsPage/taskBudgetReport/styles.scss';export default {
  "wbsReport": "_wbsReport_4lta9_1",
  "checked": "_checked_4lta9_7",
  "row": "_row_4lta9_11",
  "checkbox": "_checkbox_4lta9_20",
  "col": "_col_4lta9_26",
  "name": "_name_4lta9_30",
  "description": "_description_4lta9_37",
  "filters": "_filters_4lta9_42",
  "group": "_group_4lta9_51",
  "label": "_label_4lta9_60",
  "button": "_button_4lta9_67"
};